import PropTypes from 'prop-types';

HorizontalCustomizeWrapper.propTypes = {
  children: PropTypes.node
}

export default function HorizontalCustomizeWrapper({children}) {
  return (
    <div className="w-full mb-4 px-2 xl:ml-2 xl:-mt-5 lg:max-w-screen-lg">
      {children}
    </div>
  )
}